import "./style.css";
import * as dat from "lil-gui";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";

import { CameraRig, FreeMovementControls, CameraHelper } from 'three-story-controls'


import { gsap } from "gsap";

import firefliesVertexShader from './shaders/fireflies/vertex.glsl'
import firefliesFragmentShader from './shaders/fireflies/fragment.glsl'
// import portalVertexShader from './shaders/portal/vertex.glsl'
// import portalFragmentShader from './shaders/portal/fragment.glsl'

const loadingBarElement = document.querySelector('.loading-bar')

const loadingManager = new THREE.LoadingManager(
    // Loaded
    () =>
    {
       window.setTimeout(() =>
        {
          gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 1, value: 0, delay: 1 })

          loadingBarElement.classList.add('ended')
          loadingBarElement.style.transform = ''
        }, 100)
    },

    // Progress
    (itemUrl, itemsLoaded, itemsTotal) =>
    {
        const progressRatio = itemsLoaded / itemsTotal
        loadingBarElement.style.transform = `scaleX(${progressRatio})`
    }
)

/**
 * Base
 */
// Debug
const debugObject = {}
// const gui = new dat.GUI({
//   width: 400,
// });
// gui.close();

// Clear color
debugObject.clearColor = '#201919'
// debugObject.portalColorStart = '#4d0000'
// debugObject.portalColorEnd = '#fff'

// gui
//     .addColor(debugObject, 'portalColorStart')
//     .onChange(() =>
//     {
//         portalLightMaterial.uniforms.uColorStart.value.set(debugObject.portalColorStart)
//     })

// gui
//     .addColor(debugObject, 'portalColorEnd')
//     .onChange(() =>
//     {
//         portalLightMaterial.uniforms.uColorEnd.value.set(debugObject.portalColorEnd)
//     })

// gui
//   .addColor(debugObject, 'clearColor')
//   .onChange(() =>
//   {
//     renderer.setClearColor(debugObject.clearColor)
//   })



/**
 * Fireflies
 */
// Geometry
const firefliesGeometry = new THREE.BufferGeometry()
const firefliesCount = 30
const positionArray = new Float32Array(firefliesCount * 3)
const scaleArray = new Float32Array(firefliesCount)


for(let i = 0; i < firefliesCount; i++)
{
    positionArray[i * 3 + 0] = (Math.random() - 1.9) * 0.95
    positionArray[i * 3 + 1] = Math.random() * 0.3
    positionArray[i * 3 + 2] = (Math.random() + 0.95) * 1
    scaleArray[i] = Math.random()

}

firefliesGeometry.setAttribute('position', new THREE.BufferAttribute(positionArray, 3))
firefliesGeometry.setAttribute('aScale', new THREE.BufferAttribute(scaleArray, 1))

// Material
const firefliesMaterial = new THREE.ShaderMaterial({
    depthWrite: false,
    blending: THREE.AdditiveBlending,
    transparent: true,
    uniforms:
    {
      uTime: { value: 0 },
      uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },
      uSize: { value: 40 }
    },
    vertexShader: firefliesVertexShader,
    fragmentShader: firefliesFragmentShader
})

// gui.add(firefliesMaterial.uniforms.uSize, 'value').min(0).max(500).step(1).name('firefliesSize')

// const portalLightMaterial = new THREE.ShaderMaterial({
//     uniforms: {
//       uTime: { value: 0 },
//       uColorStart: { value: new THREE.Color(debugObject.portalColorStart) },
//       uColorEnd: { value: new THREE.Color(debugObject.portalColorEnd) }
//     },
//     vertexShader: portalVertexShader,
//     fragmentShader: portalFragmentShader
// })

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

// var sphereAxis = new THREE.AxesHelper(200);
// scene.add(sphereAxis);

/**
 * Overlay
 */
const overlayGeometry = new THREE.PlaneGeometry(2, 2, 1, 1)

const overlayMaterial = new THREE.ShaderMaterial({
    // wireframe: true,
    transparent: true,
    uniforms:
    {
        uAlpha: { value: 1 }
    },
    vertexShader: `
        void main()
        {
            gl_Position = vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform float uAlpha;
        void main()
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
        }
    `
})
// Points
const fireflies = new THREE.Points(firefliesGeometry, firefliesMaterial)
scene.add(fireflies)

const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial)
scene.add(overlay)

/**
 * Materials
 */

// Texture loader
const textureLoader = new THREE.TextureLoader();
const bakedTexture = textureLoader.load("baked.jpg");
bakedTexture.flipY = false;
bakedTexture.encoding = THREE.sRGBEncoding;
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture });

// Pole light material
const poleLightMaterial = new THREE.MeshBasicMaterial({ color: "#9C8506" });

/**
 * Loaders
 */

// Draco loader
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath("draco/");

// GLTF loader
const gltfLoader = new GLTFLoader(loadingManager);
gltfLoader.setDRACOLoader(dracoLoader);


gltfLoader.load("farm.glb?v1", gltf => {
  scene.add(gltf.scene);
  const bakedMesh = gltf.scene.children.find(child => child.name === "baked");
  // const portalLightMesh = gltf.scene.children.find(
  //   child => child.name === "portalLight"
  // );
  const lampAMesh = gltf.scene.children.find(
    child => child.name === "light1"
  );
  const lampBMesh = gltf.scene.children.find(
    child => child.name === "light2"
  );

  // Apply materials
  bakedMesh.material = bakedMaterial;
  // portalLightMesh.material = portalLightMaterial;
  lampAMesh.material = poleLightMaterial;
  lampBMesh.material = poleLightMaterial;


});



/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  // Update fireflies
  firefliesMaterial.uniforms.uPixelRatio.value = Math.min(window.devicePixelRatio, 2)
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  45,
  sizes.width / sizes.height,
  0.1,
  100
);

camera.position.x = 4;
camera.position.y = 2;
camera.position.z = 4;
scene.add(camera);



/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  antialias: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

renderer.outputEncoding = THREE.sRGBEncoding;

renderer.setClearColor(debugObject.clearColor)

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;
controls.maxPolarAngle = Math.PI / 2;

//  const rig = new CameraRig(camera, scene)
//  const controls = new FreeMovementControls(rig, {
//     domElement: canvas,
//   })
//   controls.enable()

  // const cameraHelper = new CameraHelper(rig, controls, renderer.domElement)

/**
 * Animate
 */
const clock = new THREE.Clock();

const tick = (t) => {
  const elapsedTime = clock.getElapsedTime();

  // Update controls
  controls.update();
  // cameraHelper.update(t)

  // Render
  renderer.render(scene, camera);

  // Update materials
  firefliesMaterial.uniforms.uTime.value = elapsedTime

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
